import * as S from './BookACallButton.styled';

type Props = {
    payVisaFee: () => void;
    style?: React.CSSProperties;
};
export default function ColorfulBtn({ payVisaFee, style }: Props) {
    const actionButton = () => {
        payVisaFee();
    };
    return (
        <S.Button style={{ ...style }} onClick={() => actionButton()}>
            <S.PhoneIcon />
            Get Expert Consultation!
        </S.Button>
    );
}
